import Button from "@/pages/taskpane/components/ui/Button";
import { useTranslation } from "react-i18next";
import { usePreSelectedResourceStore } from "@/pages/taskpane/shared/stores/preSelectedResourceStore";
import React from "react";
import ProcessAlternative from "./ProcessAlternative";
import { useThemeStore } from "@/pages/taskpane/shared/stores";
import { CityRegular } from "@/pages/taskpane/components/icons/IconCustom";
import { PreSelectedResourceInfo } from "@/pages/taskpane/shared/types/preSelectedResource";

type Props = {
  notifyInfo?: PreSelectedResourceInfo;
};

const AlternativeResource = ({ notifyInfo }: Props) => {
  const { t } = useTranslation();
  const { isDarkMode } = useThemeStore();
  const { setIsProcessingAlternativeResource, isProcessingAlternativeResource } = usePreSelectedResourceStore();

  const handleClickAlternativeResource = () => {
    setIsProcessingAlternativeResource(true);
  };

  const handleClickCancel = () => {
    setIsProcessingAlternativeResource(false);
  };

  const renderProcessingAlternativeResource = () => {
    return <ProcessAlternative />;
  };

  const renderWarningAlternativeResource = () => {
    return (
      <div className="flex flex-col gap-6 px-5 py-4">
        <div className="flex gap-2">
          <div>
            <CityRegular isDarkMode={isDarkMode} />
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-sm font-medium text-gray-900 dark:text-white">
              {t("Selected Resource: {{resourceName}} Conflicting Occurrences", {
                resourceName: notifyInfo?.resources[0]?.name,
              })}
            </span>
            <div className="flex justify-between">
              <div className="flex flex-col gap-2">
                <span className="text-xs font-normal text-gray-900 dark:text-white">14/11/2025</span>
                <span className="text-xs font-normal text-gray-900 dark:text-white">15/11/2025</span>
                <span className="text-xs font-normal text-gray-900 dark:text-white">14/11/2025</span>
                <span className="text-xs font-normal text-gray-900 dark:text-white">15/11/2025</span>
              </div>
              <div className="flex flex-col justify-center">
                <Button
                  className="bg-white text-black border border-[#0f548c] w-[125px] h-[32px] dark:text-white dark:border-[#96c6fa] text-xs"
                  label={t("Alternative Resource")}
                  onClick={handleClickAlternativeResource}
                />
              </div>
            </div>
            <div className="flex justify-start mt-4 gap-3 border-t border-gray-200 pt-4 dark:border-darkMediumGray">
              <Button
                className="bg-primaryBlue text-white w-[100%] h-[32px] dark:bg-brightBlue dark:text-black text-xs"
                label={t("OK")}
                onClick={handleClickAlternativeResource}
              />
              <Button
                className="bg-white text-black border border-lightGray w-[100%] h-[32px] dark:text-white dark:border-darkMediumGray text-xs"
                label={t("Cancel")}
                onClick={handleClickCancel}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return isProcessingAlternativeResource ? renderProcessingAlternativeResource() : renderWarningAlternativeResource();
};

export default AlternativeResource;
